export default {
  "title": "FreeDive Ai",
  "heroHeadline": "Тренируйтесь каждый день и улучшайте свои навыки фридайвинга!",
  "heroSubheadline": "Идеальное приложение для тренировок по апноэ с ИИ для фридайверов, подводных охотников и русалок.",
  "featuresHeader": "Почему стоит выбрать FreeDive Ai?",
  "featuresSubtitle": "Всё необходимое для того, чтобы нырять глубже, задерживать дыхание дольше и оставаться в безопасности.",
  "feature1Title": "ИИ-тренировки по апноэ",
  "feature1Desc": "Индивидуальные таблицы CO2 и O2, сгенерированные ИИ на основе ваших личных рекордов, для безопасного увеличения времени задержки дыхания.",
  "feature2Title": "Умный журнал",
  "feature2Desc": "Записывайте свои сессии фридайвинга и подводной охоты. Отслеживайте глубину, время, частоту пульса и SpO2 в одном месте.",
  "feature3Title": "Соревнования и лицензии",
  "feature3Desc": "Следите за своими лицензиями по фридайвингу и будьте в курсе глобальных соревнований и событий.",
  "screenshotsTitle": "Скриншоты приложения",
  "copyright": "© DomiLabs. All rights reserved."
};
